<template>
  <div class="pageWrap indexPage"> 
    <div class="bannerWrap">
        <div class="pageCenter">
            <div class="leftBlock">
                <div class="mainTitle">Hi，欢迎使用衣加加云平台！</div>
                <div class="subTitle">打造服装产业一站式服务平台，提升效率，降低业务成本。</div>
            </div>
            <div class="rightBlock">
                <div class="textBlock">
                    <div class="mainTitle">
                        <span>{{identifyText[userType]}}</span>

                        <span class="authTag yellowTag" v-if="userIsAuth == 'y'">已认证</span>
                        <span class="authTag yellowTag" v-else-if="userIsAuth == 'p'">认证审核中</span>
                        <span class="authTag redTag" v-else-if="userIsAuth == 'n'">认证被拒绝</span>
                        <span class="authTag" v-else-if="userIsAuth == 'never'">未认证</span>
                    </div>
                    <div class="subTitle inaline" v-if="userInfo.companyName">{{userInfo.companyName}}</div>
                    <span class="to-auth" :class="{large: userInfo.companyName == ''}"
                        v-if="userIsAuth == 'never'" @click="toAuthPage"
                    >
                        前往认证{{userInfo.companyName == '' ? '身份信息' : ''}} &gt;&gt;
                    </span>
                    <span class="to-auth" :class="{large: userInfo.companyName == ''}"
                        v-if="userIsAuth == 'n'" @click="toAuthPage">
                        重新认证{{userInfo.companyName == '' ? '身份信息' : ''}} &gt;&gt;
                    </span>
                </div>
                <div class="avatarBox">
                    <img src="../../assets/home/img_xuanfukuang@2x.png" alt="" class="avatarImg">
                </div>
                <div class="btnLineBox" v-if="userType == 1">
                    <div class="btnBox">
                        <button  class="btn blueBtn" @click="toAddOrder('oem')">发布包工包料订单</button>
                    </div>
                    <div class="btnBox">
                        <button class="btn blueBtn" @click="toAddOrder('cmt')">发布来料加工订单</button>
                    </div>
                </div>
                <div class="btnLineBox" v-if="userType == 2">
                    <div class="btnBox">
                        <button  class="btn blueBtn" @click="toTakeOrder('1')">接加工订单</button>
                    </div>
                    <div class="btnBox">
                        <button class="btn blueBtn" @click="toTakeOrder('2')">优先推送给我的订单</button>
                    </div>
                </div>
            </div>
            <div class="bottomBLock">
                <div class="oneBlock">
                    <div class="innerContent">
                        <div class="labelLine">生产发单数(笔)</div>
                        <div class="numberLine">{{statData.orderCountByProduct}}</div>
                    </div>
                </div>
                <div class="oneBlock">
                    <div class="innerContent">
                        <div class="labelLine">云仓下单订单数(笔)</div>
                        <div class="numberLine">{{statData.orderCountByDe}}</div>
                    </div>
                </div>
                <div class="oneBlock">
                    <div class="innerContent">
                        <div class="labelLine">云仓被下单订单数(笔)</div>
                        <div class="numberLine">{{statData.orderCountBySup}}</div>
                    </div>
                </div>
                <div class="oneBlock">
                    <div class="innerContent">
                        <div class="labelLine">云仓清算订单数(笔)</div>
                        <div class="numberLine">{{lqCount}}</div>
                    </div>
                </div>
                <div class="oneBlock">
                    <div class="innerContent">
                        <div class="labelLine">订货会场次(场)</div>
                        <div class="numberLine">{{statData.totalSum}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sectionBLock">
        <div class="sectionTitle">数字云仓</div>
        <div class="sectionSubTitle">
            综合体数字云仓是基于全行业多个零售场景而设计搭建的数字化销售线上线下一站式平台，
            <br>
            平台汇聚本地优质企业，打通多渠道资源，补充企业短板。
            
        </div>
        <div class="typeBlock">
            <el-row :gutter="24">
              <el-col :span="8" >
                  <div class="oneInnerBlock" @click="toDwShop">
                      <img src="../../assets/home/ic_yuncangshangchang@2x(1).png" alt="">
                      <div class="mainName">云仓商城</div>
                      <div class="subName">运营配套健全的线下仓储物流体系、先进的技术保障</div>
                  </div>
              </el-col>
              <el-col :span="8" >
                  <div class="oneInnerBlock" @click="toDwShopIntro">
                      <img src="../../assets/home/ic_yuncangjieshao@2x.png" alt="">
                      <div class="mainName">云仓介绍</div>
                      <div class="subName">数字化销售线上线下一站式平台</div>
                  </div>
              </el-col>
              <el-col :span="8" >
                  <div class="oneInnerBlock" @click="toDwShopEnter">
                      <img src="../../assets/home/ic_ruzhuyuncang@2x.png" alt="">
                      <div class="mainName">入驻云仓</div>
                      <div class="subName">诚邀您加入我们，携手共同打造数字化销售平台</div>
                  </div>
              </el-col>
            </el-row>
        </div>
    </div>
    <div class="sectionBLock">
        <div class="sectionTitle">订货服务</div>
        <div class="sectionSubTitle">服装产业云平台旗下的一个SaaS服务模块, 意在帮助品牌商更有效的进行<br>发布会/订货会客户邀约、商品管理、订单管理</div>
        <div class="typeBlock">
            <el-row :gutter="24">
              <el-col :span="8" >
                  <div class="oneInnerBlock" @click="toOrderSystem">
                      <img src="../../assets/home/ic_dinghuoxitong@2x.png" alt="">
                      <div class="mainName">订货系统</div>
                      <div class="subName">邀约、管理、线上线下结合的模块化全流程系统</div>
                  </div>
                  
              </el-col>
              <el-col :span="8" >
                  <div class="oneInnerBlock" @click="toOrderMeeting">
                      <img src="../../assets/home/ic_dinghuohui@2x.png" alt="">
                      <div class="mainName">订货会</div>
                      <div class="subName">发布会-订货会一站式整体解决方案</div>
                  </div>
                  
              </el-col>
            </el-row>
        </div>
    </div>
    <div class="sectionBLock">
        <div class="fabricBox" @click="toFabric">
            <img src="../../assets/home/fabricBanner.jpg" alt="" class="fabricImg">
            <div class="desArea">
                <div class="desTitle">纺织印花采购</div>
                <div class="desSubTitle">为您提供海量丰富的花型、面料选择，智能的试衣效果展示</div>
            </div>
            
        </div>
    </div>
   
   
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api/index.js'
import request from '@/utils/request'
import { toDwSystem, toBrandOrderingSystem } from '@/utils/freeLogin'

export default {
    computed: {
        ...mapGetters(['userType', 'userIsAuth', 'userInfo', 'servicePhone', 'userId']),
        lqCount: function() {
            let count =  ( + this.statData.lqCountByDe) + ( + this.statData.lqCountBySup)
            return isNaN(count) ? '0' : count
        }
    },
    data() {
        return {
            identifyText: {
                1: '品牌商',
                2: '生产商',
                9: '直播相关'
            },
            statData: {
                lqCountByDe: "0",         // 用户作为销售商的清算笔数
                lqCountBySup: "0",        // 用户作为供应商的清算笔数
                orderCountByDe: "0",      // 用户作为销售商下单笔数
                orderCountBySup: "0",     // 用户作为供应商被下单笔数
                orderCountByProduct: "0", // 生产加工发单数量
                totalSum: "0",            // 参与订货会活动次数
            }
        }
    },
    created() {
        this.getStatisticData()
    },
    methods: {
        toFabric(){
          this.$router.push("/fabric")
        },  

        getStatisticData() {
            request({
                url: api.getStatisticData,
                data: {
                    userId: this.userId
                }
            }).then(res => {
                // console.log(res)
                if (res.errorCode == 200) {
                    this.statData = res.data
                }
            })
        },
        toDwShopEnter(){
           this.$router.push('/enterDw')
        },
        toDwShopIntro(){
            window.open('https://www.fzzht.com/products-digital-warehouse.html', '_blank')
        },
        toDwShop(){
            toDwSystem()
            // window.open('https://dw.fzzht.com/', '_blank')
        },
        toOrderSystem(){
            toBrandOrderingSystem()
            // window.open('https://www.fzzht.com/products-ordering-system.html', '_blank')
        },
        toOrderMeeting(){
            window.open('https://www.fzzht.com/solutions-ordering-conference.html', '_blank')
        },
        toAuthPage() {
            this.$router.push('/auth')
        },
        toAddOrder(type){
            if (this.userIsAuth == 'never') {
                this.$confirm('您还未认证企业信息，请先进行认证，才能发单', '企业未认证', {
                    confirmButtonText: '去认证',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('/auth')
                })
            }
            if (this.userIsAuth == 'n') {
                this.$confirm('您的企业信息认证未通过，不能发单，请重新认证', '认证被拒绝', {
                    confirmButtonText: '去认证',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('/auth')
                })
            }
            if (this.userIsAuth == 'p') {
                this.$confirm('您的企业信息认证审核中，认证通过后可以发单。可以拨打客服电话' + this.servicePhone +  '进行咨询', '认证审核中', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {
                    // 确定
                })
            }
            if (this.userIsAuth == 'y') {
                if(type=='oem'){
                    this.$router.push('/addOem')
                }else if(type=='cmt'){
                    this.$router.push('/addCmt')
                }
            }
            
        },
        toOrderList(){
            this.$router.push('/order')
        },
        toTakeOrder(type) {
            if (type == '1') {
                this.$router.push('/list-take-order')
            } else if (type == '2') {
                this.$router.push('/list-push-me')
            }
        },
    }
}
</script>

<style scoped="scoped" lang="scss">
    // *{outline: 1px solid blue;}
    .pageWrap{text-align: center;padding-bottom: 40px;}
    .bannerWrap{
        text-align: center;position: relative; height:300px;
        background: #3F33FF url(../../assets/home/bigbanner.png) no-repeat;
        background-size: 100% 100%;
        margin-bottom: 88px;;
        
        .pageCenter{
            width: 1184px;height: 300px;
            display: inline-block;
            text-align: left; position: relative;
            
            .leftBlock{
                 color:#fff;
                 .mainTitle{font-size: 30px;line-height: 38px;margin-top:94px;margin-bottom: 8px;}
                 .subTitle{
                     line-height: 24px;
                     font-size: 16px; opacity:0.85;
                 }
             }
             .rightBlock{
                 box-sizing: border-box; width: 380px; height:174px; padding:24px;background: #fff;;border-radius: 4px;
                 position: absolute;top:48px;right:0;
                 .textBlock{
                     .mainTitle{
                         font-size: 14px;
                         font-weight: 400;
                         color: rgba(0, 0, 0, 0.85);
                         line-height: 20px;margin-bottom: 9px;
                         
                         .authTag{margin-left: 8px;}
                     }
                     .subTitle{
                         font-size: 20px;
                         font-weight: 500;
                         color: rgba(0, 0, 0, 0.85);
                         line-height: 28px;
                         max-width: 200px;
                         display: inline-block;
                         margin-right: 8px;
                     }
                     .to-auth {
                        display: inline-block;
                        font-size: 12px;
                        font-weight: 500;
                        color: #FAAD14;
                        line-height: 28px;
                        vertical-align: bottom;
                        cursor: pointer;
                        &.large {
                            font-size: 20px;
                        }
                        &:hover {
                            color: #ec9e04;
                        }
                     }
                 }
                 .avatarBox{
                     position: absolute;top:13px;right:24px;
                     .avatarImg{
                         width: 80px;height: 80px;
                     }
                 }
             }
             .btnLineBox{
                 position: absolute;
                 bottom: 24px;
                 left: 24px;
                 display: flex;
                 .btnBox {
                    flex: none;
                 }
                 .btnBox:last-child{margin-left: 16px;}
                 
             }
            
            .bottomBLock{
                width: 100%;height:112px ;background: #FFFFFF;box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.15);border-radius: 4px;
                position: absolute; bottom:-88px; padding:24px;box-sizing: border-box;
                display: flex;
                .oneBlock{
                    flex:1; text-align: center;
                    .innerContent{
                        text-align: left;
                        display: inline-block;
                        .labelLine{
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 22px;
                            height: 22px;
                            margin-bottom: 4px;
                        }
                        .labelLine::before{content: " ";display: inline-block;background: #2F54EB;width: 6px;height: 6px;border-radius: 50%;margin-right: 8px;}
                        .numberLine{
                            font-size: 30px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 38px; height: 38px;
                            padding-left:14px;
                        }
                    }
                    
                }
                .oneBlock:nth-child(1) .labelLine::before{background: #FF4D4F;}
                .oneBlock:nth-child(2) .labelLine::before{background: #52C41A}
                .oneBlock:nth-child(3) .labelLine::before{background: #13C2C2;}
                .oneBlock:nth-child(4) .labelLine::before{background: #1890FF;}
                .oneBlock:nth-child(5) .labelLine::before{background: #2F54EB;}
            }
        }
        
    }
    .sectionBLock{
        width: 1184px;display: inline-block;margin-top:80px;
        .sectionTitle{
            
            height: 32px;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 32px;
            margin-bottom: 4px;
        }
        .sectionSubTitle{
            
            // height: 24px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 24px;
            margin-bottom: 40px;
        }
        .typeBlock{
            .oneInnerBlock{
                height: 208px;
                background: #FFFFFF;
                border-radius: 8px;
                img{height: 70px;margin-top:38px;}
                .mainName{margin-top: 4px;
                    
                    height: 22px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                    margin-bottom: 4px;
                }
                .subName{
                    
                    height: 17px;
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.45);
                    line-height: 17px;
                }
            }
            .oneInnerBlock:hover{box-shadow: 0px 0px 6px #dfdfff; cursor: pointer;}
        }
    }
    .fabricBox{
        position: relative;
        .fabricImg{
            width: 100%;display: block;
            border-radius: 8px;
        }
        .desArea{
            position: absolute;top:70px;right:60px;text-align: right;
            .desTitle{
                font-size: 24px;
                font-weight: 500;
                color: #3F33FF;
                line-height: 33px;
                margin-bottom: 4px;
            }
            .desSubTitle{
                
                font-size: 16px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                line-height: 24px;
            }
        }
        
    }
    .fabricBox:hover{
        box-shadow: 0 4px 20px #eee;
        cursor: pointer;
        border-radius: 8px;
    }

</style>